import { SubTitleVariant } from 'app/components/shared/HeaderWave'
import React, { createContext } from 'react'

type HeaderContext = {
  headerTitle: string
  headerSubTitle?: string
  subTitleVariant?: SubTitleVariant
  updateTitles: (title: string, subTitle?: string) => void
  updateSubTitle: (subTitle?: string) => void
  updateSubtitleVariant: (subTitleVariant?: SubTitleVariant) => void
}

export const HeaderContext = createContext<HeaderContext | null>(null)

export const HeaderProvider: React.FC = ({ children }) => {
  const [headerTitle, setHeaderTitle] = React.useState('')
  const [headerSubTitle, setHeaderSubTitle] = React.useState<
    string | undefined
  >('')
  const [subTitleVariant, setSubtitleVariant] = React.useState<
    SubTitleVariant | undefined
  >()

  return (
    <HeaderContext.Provider
      value={{
        headerTitle,
        headerSubTitle,
        subTitleVariant,
        updateTitles: (title, subTitle) => {
          setHeaderTitle(title)
          setHeaderSubTitle(subTitle || '')
        },
        updateSubTitle: subTitle => {
          setHeaderSubTitle(subTitle || '')
        },
        updateSubtitleVariant: subTitleVariant => {
          setSubtitleVariant(subTitleVariant)
        },
      }}
    >
      {children}
    </HeaderContext.Provider>
  )
}
